import Radio from 'antd/es/radio';
import styled, { css } from 'styled-components';

import { PaletteColor, GetSCProps } from '@utils/types';

export type RadioGroupStyleProps = GetSCProps<
  'color',
  {
    selectedOptionColor: PaletteColor;
    direction?: 'row' | 'column';
  }
>;

const directionDisplayMixin = ({ direction }: RadioGroupStyleProps) =>
  direction === 'column'
    ? css`
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
      `
    : css`
        margin-right: 25px;
        &:last-child {
          margin-right: 0;
        }
      `;

export const RadioGroupContainer = styled(Radio.Group)<RadioGroupStyleProps>`
  &&& {
    .setur-radio {
      top: 0;
    }
    .setur-radio-inner {
      height: 20px;
      width: 20px;
      background-color: ${({ theme }) => theme.palette.white} !important;
      &::after {
        border: 0;
        margin-left: 0px;
        margin-top: 0px;
        width: 18px;
        height: 18px;
        transform: translate(-50%, -50%) scale(1) !important;
      }
    }
    .setur-radio-checked .setur-radio-inner {
      background-color: ${({ theme }) => theme.palette.white};

      &:after {
        transform: scale(1);
        border: 4.5px solid ${({ theme }) => theme.palette.primaryBrand};
      }
    }
    .setur-radio-wrapper:hover .setur-radio,
    .setur-radio:hover .setur-radio-inner,
    .setur-radio-input:focus + .setur-radio-inner {
      border-color: ${({ theme }) => theme.palette.darkGray};
    }
    .setur-radio-input:focus + .setur-radio-inner {
      box-shadow: 0 0 0 3px rgb(232, 182, 90, 0.08);
    }
    .setur-radio-wrapper {
      margin-right: 0;
      color: ${({ theme, color }) => color ?? theme.palette?.brownishGrey};
      span.setur-radio + span {
        padding: 0 0 0 10px;
      }
      ${directionDisplayMixin}
      align-items: center;
    }
    && {
      display: flex;
      flex-direction: ${(p) => p.direction};
    }
  }
`;
